export function truncate(string: string, maxLength = 20): string {
  if (!string) return ''
  if (string.length <= maxLength) return string
  return `${string.substring(0, maxLength)}...`
}

export function timeToRead(text: string): number {
  return Math.ceil(text.split(' ').length / 250)
}

export function quixoticLink(tokenId: number): string {
  const contractAddress = process.env.NEXT_PUBLIC_TESTERS_NFT_ADDRESS
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return tokenId > 0
      ? `https://quixotic.io/asset/${contractAddress}/${tokenId}`
      : `https://quixotic.io/profile`
  }
  return tokenId > 0
    ? `https://testnet.quixotic.io/asset/${contractAddress}/${tokenId}`
    : `https://testnet.quixotic.io/profile`
}

export function discordLink(): string {
  return `https://discord.gg/YDcfdnCs`
}
